/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    {
      title: t('general.course'),
      field: 'course',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span
          className="tooltip-test"
          title={rowData.schoolClass.courseStep.course.label}
        >
          {rowData.schoolClass.courseStep.course.label}
        </span>
      ),
    },
    {
      title: t('general.time-period'),
      field: 'term',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.schoolClass.term.name}>
          {rowData.schoolClass.term.name}
        </span>
      ),
    },
    {
      title: t('general.cycle'),
      field: 'cycleName',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.cycleName}>
          {rowData.cycleName}
        </span>
      ),
    },
    {
      title: t('general.school-class'),
      field: 'schoolClass',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title="">
          {rowData.schoolClass.label}
        </span>
      ),
    },
    { title: t('general.status'), field: 'status' },
    {
      title: t('general.discipline'),
      field: 'subject',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.subject.name}>
          {rowData.subject.name}
        </span>
      ),
    },
  ];
}
